export default () => (
  <svg width="155" height="236" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path
        fillOpacity=".298"
        fill="#D6D8E5"
        d="M90.246 214.147l28.14-16.246-28.14-16.26-28.155 16.26zM45.649 188.123l28.155-16.245-28.155-16.26-28.14 16.26z"
      />
      <path fill="#00B5DD" d="M28.95 32.49l28.154-16.245L28.95 0 .81 16.245z" />
      <path
        fill="#00B5DD"
        d="M28.95 178.805l28.154-16.26V16.235L28.95 32.495z"
      />
      <path
        fillOpacity=".098"
        fill="#000"
        d="M28.95 178.805l28.154-16.26V16.235L28.95 32.495z"
      />
      <path fill="#007BB9" d="M.827 162.545l28.14 16.26V32.495L.827 16.235z" />
      <path
        fill="#00B5DD"
        d="M71.148 105.584l28.155-16.26-28.155-16.26-28.14 16.26z"
      />
      <path
        fill="#00B5DD"
        d="M71.148 202.999l28.155-16.245v-97.44l-28.155 16.26z"
      />
      <path
        fillOpacity=".098"
        fill="#000"
        d="M71.148 202.999l28.155-16.245v-97.44l-28.155 16.26z"
      />
      <path
        fill="#007BB9"
        d="M43.025 186.754l28.14 16.245v-97.425l-28.14-16.26z"
      />
      <path
        fillOpacity=".298"
        fill="#D6D8E5"
        d="M126.268 235.433l28.155-16.245-28.155-16.26-28.14 16.26z"
      />
      <path
        fill="#00B5DD"
        d="M116.075 182.756l28.155-16.26-28.14-16.245-28.155 16.245z"
      />
      <path
        fill="#00B5DD"
        d="M116.075 229.336l28.155-16.26v-46.59l-28.155 16.26z"
      />
      <path
        fillOpacity=".098"
        fill="#000"
        d="M116.075 229.336l28.155-16.26v-46.59l-28.155 16.26z"
      />
      <path
        fill="#007BB9"
        d="M87.952 213.076l28.14 16.26v-46.59l-28.14-16.26z"
      />
      <path
        d="M68.505 64.438a54.829 54.829 0 01-7.785 10.605c-.84.975-7.32-1.5-6-2.19 1.32-.69 5.596-6.615 7.71-10.5a131.168 131.168 0 004.5-14.415c1.335-4.815 2.475-11.895 3.45-15.225a6.525 6.525 0 014.965-5.04c2.326-.54 3.84.09 3.42 2.91-.674 4.905-4.545 24.135-10.26 33.855z"
        fill="#DFAE8E"
      />
      <path
        d="M72.229 139.682c-2.01 1.636-4.98.136-5.13.285a85.945 85.945 0 01-7.41 6.18c-1.245.975-3.195 2.295-2.85 4.186.63 3.39 6 2.34 8.1 1.305 2.1-1.036 3.705-2.745 5.64-3.945 1.38-.855 2.745-1.305 3-3 .09-1.035-1.005-5.055-1.35-5.01z"
        fill="#38226D"
      />
      <path
        d="M73.504 143.94c-.255 1.68-1.605 2.13-3 3-1.965 1.215-3.69 3-5.745 4.02-2.055 1.02-6.585 1.905-7.92-.51.72 3.255 6 2.235 8.07 1.2 2.07-1.035 3.705-2.745 5.64-3.945 1.38-.855 2.745-1.305 3-3a4.165 4.165 0 00-.045-.765z"
        fill="#757B89"
      />
      <path
        d="M51.871 127.96c-2.01 1.635-5.52-.15-5.67 0a75.477 75.477 0 01-6.615 6c-1.26.99-3.21 2.31-2.85 4.2.63 3.39 6 2.34 8.085 1.305 2.085-1.035 3.72-2.745 5.655-3.945 1.38-.855 2.73-1.305 3-3a9.092 9.092 0 00-1.605-4.56z"
        fill="#38226D"
      />
      <path
        d="M53.356 131.977c-.255 1.665-1.605 2.13-3 3-1.964 1.215-3.69 3-5.73 4.005-2.04 1.005-6.6 1.905-7.934-.51.72 3.27 6 2.235 8.07 1.215 2.07-1.02 3.704-2.745 5.64-3.945 1.38-.855 2.744-1.305 3-3a2.983 2.983 0 00-.046-.765z"
        fill="#757B89"
      />
      <path
        d="M99.048 75.376c2.22 13.905-3.946 19.08-12 22.05-5.76 2.115-14.026 5.385-14.026 5.385s.12 3 .18 9.9c0 6-.734 28.035-.734 28.035-1.93.99-4.22.99-6.15 0 0 0-3.24-16.86-3.93-24.465-.93-10.32-2.506-17.07-1.98-19.29.465-1.95 11.73-7.5 15.314-10.5l-23.625 7.92c.473 2.553.709 5.143.705 7.74-.21 8.175-.675 25.89-.675 25.89s-3.24 2.34-6 0c0 0-6-35.07-5.22-39.705.69-4.41 21.496-13.41 25.17-16.5a5.85 5.85 0 014.62-1.245l28.35 4.785z"
        fill="#38226D"
      />
      <path
        d="M90.83 23.07s-.344 6.63-.194 7.215c.15.585 3 2.52 3.885 3.225.884.705-4.575 6-7.215 7.245-2.64 1.245-10.98-1.98-11.13-6-.15-4.02 1.5-7.5 2.715-7.725 1.214-.225 11.94-3.96 11.94-3.96z"
        fill="#DFAE8E"
      />
      <path
        d="M91.562 31.424s-4.8 7.155-11.504 7.83c-2.116-2.085-2.296-9.495.63-11.865 0 0-2.7-2.16-4.5-1.74a9.45 9.45 0 00-4.14 5.28 43.12 43.12 0 00-2.4 15.3c.12 7.02 0 24.78 0 24.78a15.12 15.12 0 007.065 10.17 21.801 21.801 0 0015.9 2.19 7.922 7.922 0 005.834-5.145c-.314-4.935-2.265-15-1.5-21.255.766-6.255 2.13-10.815 2.476-15.81.344-4.995-.66-4.905-3.18-6.69a39.854 39.854 0 00-4.68-3.045z"
        fill="#F4F4F4"
      />
      <path
        d="M75.845 13.242c.795-5.145 4.5-9 9.795-8.745 5.633.306 9.952 5.121 9.646 10.754v.016a10.097 10.097 0 01-4.5 7.83 9.907 9.907 0 01-.826 2.25c-1.86 2.19-7.5 3.555-9.165 3.315a4.846 4.846 0 01-4.215-3.45c-1.725-4.05-1.17-9.45-.735-11.97z"
        fill="#DFAE8E"
      />
      <path
        d="M90.83 23.083l-.481-4.5s3.66-9.48-4.995-7.65c-5.715 1.2-7.155 1.71-8.895-2.115-1.74-3.825 4.395-7.29 11.685-6.33a10.066 10.066 0 019 10.215c-.195 2.835-.945 8.55-6.315 10.38z"
        fill="#3A2C6D"
      />
      <path
        d="M69.992 39.704a5.218 5.218 0 01-3.495-1.5c.195-2.46 3.345-11.805 9.675-12.495a11.6 11.6 0 00-3.96 4.77 61.492 61.492 0 00-2.22 9.225z"
        fill="#EDEDED"
      />
      <path
        d="M43.155 81.356l15.339-8.875a.85.85 0 01.878 0L86.266 88.05 70.494 97.18 43.155 81.356z"
        fill="#F4F4F4"
      />
      <path
        fillOpacity=".149"
        fill="#000"
        d="M74.549 82.656l-4.055 2.358-7.203-4.173 4.055-2.344z"
      />
      <path
        d="M86.266 88.049v.366a1.48 1.48 0 01-.73 1.287l-14.298 8.265c-.454.269-1.02.269-1.473 0L43.899 83.063c-.48-.277-.767-.8-.744-1.355v-.366l27.34 15.825 15.77-9.118z"
        fill="#E5E5E5"
      />
      <path
        d="M70.09 97.397a1.753 1.753 0 01-1.514-.108L42.898 82.385a1.75 1.75 0 01-.851-1.233l-2.824-16.854a1.93 1.93 0 010-.285c-.002-.47.189-.92.527-1.246l26.758 15.486c.325.2.551.53.621.908l2.96 18.236z"
        fill="#F4F4F4"
      />
      <path
        d="M70.494 97.18l-.175.11-.23.107-3.054-18.236a1.358 1.358 0 00-.622-.908l-26.69-15.486c.098-.112.217-.204.35-.271l26.813 15.513c.331.198.562.528.635.908l2.973 18.264z"
        fill="#E5E5E5"
      />
      <path
        d="M83.864 88.478a33.869 33.869 0 013.765-2.16 7.81 7.81 0 003.21-1.95c1.185-1.155 3.105-5.52 4.5-9.78a43.124 43.124 0 001.62-14.775c-.585-6-2.73-14.325-3.27-17.76-.54-3.435.555-4.8 2.16-6 1.875-1.5 4.5-.825 5.85 3.99a93.159 93.159 0 013 20.385 46.652 46.652 0 01-2.325 15 54.583 54.583 0 01-5.745 11.835c-.66 1.11-.87 2.085-1.875 4.35a15.31 15.31 0 01-4.395 5.85c-1.695 1.215-2.49 1.38-2.88 1.155-.39-.225-.39-.84.315-1.5a12.734 12.734 0 003-3.375s-1.5 1.5-2.445 2.295a12.623 12.623 0 01-2.805 1.785c-.99.435-2.355-.405-1.65-1.065.705-.66 1.41-.99 2.805-2.205a11.572 11.572 0 002.1-2.13c-.987.753-2.03 1.43-3.12 2.025a5.31 5.31 0 01-2.835.765c-.525 0-1.155-.75-.18-1.5a19.23 19.23 0 003.675-2.49c1.08-1.08 1.68-1.98 1.38-1.995-.3-.015-.885.645-2.145 1.05s-2.61 0-2.775-.66c-.165-.66-.12-.555 1.065-1.14z"
        fill="#DFAE8E"
      />
      <path
        d="M105.644 48.803s-4.725 4.695-10.32 3.345c-.795-.54-2.715-11.52-2.715-11.52s0-6.09 4.665-6c4.665.09 8.37 14.175 8.37 14.175z"
        fill="#EDEDED"
      />
    </g>
  </svg>
);
